import { render, staticRenderFns } from "./ImportReceiving.vue?vue&type=template&id=2f30d4dc&"
import script from "./ImportReceiving.vue?vue&type=script&lang=js&"
export * from "./ImportReceiving.vue?vue&type=script&lang=js&"
import style0 from "./ImportReceiving.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports